import { observer } from "mobx-react-lite";
import useDefaultMapLayer from "../../hooks/useDefaultMapLayer";

function ZoningMapLayer() {
    useDefaultMapLayer(false, map => map.getStyle()!.layers
        .filter((l: any) => l.metadata && l.metadata["mapbox:group"] === "f72b04906eef043c59fb4376cd27e825")
        .map(l => l.id));

    return (
        <></>
    );
}

export default observer(ZoningMapLayer);